export {default} from "./Registro"